var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('ckeditor',{attrs:{"id":"advantage_conditions","editor":_vm.editor},model:{value:(_vm.value.advantage_conditions),callback:function ($$v) {_vm.$set(_vm.value, "advantage_conditions", $$v)},expression:"value.advantage_conditions"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }